import Backstage from './Backstage.interface';
import NftData from './NftData.interface';
import { UserData } from './UserData.interface';

export enum NotificationType {
  LIKE = 0,
  COMMENT = 1,
  SUBSCRIPTION = 2,
  CONTENT = 3,
  FOLLOW = 4,
}
export interface Notification {
  id: number;

  nft?: NftData;

  backstage?: Backstage;

  notificationType: NotificationType;

  to: UserData;

  from: UserData;

  isRead: boolean;
}

export interface CreateNotification {
  fromId: number;
  toId: number;
  nftId?: number;
  backstageId?: number;
  notificationType: NotificationType;
}

export interface CreateOtrNotification {
  fromId: number;
  toId: number;
  otrId?: number;
  backstageId?: number;
  notificationType: NotificationType;
}
